import { createTranslationRef } from '@backstage/frontend-plugin-api';
import enMessages from './translations/en.json';

export const spikeOAuthRequestDialogTranslationRef = createTranslationRef({
  id: 'plugin.spike-oauth-dialog',
  messages: enMessages,
});
